(() => {
  if (customElements.get('hh-product-resources')) return;
  class ProductResources extends HTMLElement {
    connectedCallback() {
      if (this.onVariant || this.dataset.enabled === 'false') return;
      this.productRoot = document.querySelector('main [data-product-root]');
      this.onVariant = event => {
        if (event.target === this.productRoot) this.refresh(event.detail?.variantId);
      };
      document.addEventListener('hh:variant:change', this.onVariant);
    }
    disconnectedCallback() {
      document.removeEventListener('hh:variant:change', this.onVariant);
      this.onVariant = null;
      this.request?.abort();
      clearTimeout(this.timeout);
    }
    syncLayout() {
      this.dispatchEvent(new CustomEvent('hh:resources:updated', { bubbles: true }));
    }
    async refresh(variantId) {
      this.request?.abort();
      clearTimeout(this.timeout);
      const request = this.request = new AbortController();
      // Never leave a previous variant's manual or safety sheet visible during a change.
      this.hidden = true;
      this.querySelector('[data-resource-content]').hidden = true;
      this.querySelector('[data-resource-error]').hidden = true;
      this.syncLayout();
      if (!variantId) return;
      const url = new URL(this.dataset.sourceUrl, location.href);
      if (url.origin !== location.origin) return;
      const view = new URL(location.href).searchParams.get('view');
      if (view) url.searchParams.set('view', view);
      url.searchParams.set('variant', variantId);
      const reloadUrl = url.href;
      url.searchParams.set('section_id', this.dataset.sectionId);
      this.timeout = setTimeout(() => request.abort(), 10000);
      try {
        const response = await fetch(url.href, { signal: request.signal });
        if (!response.ok) throw new Error('Resource request failed');
        const next = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('hh-product-resources');
        if (this.request !== request || !this.isConnected) return;
        if (!next || next.dataset.variantId !== String(variantId) || next.dataset.sectionId !== this.dataset.sectionId) throw new Error('Resources did not match this option');
        this.replaceChildren(...next.childNodes);
        this.dataset.variantId = String(variantId);
        this.hidden = next.hidden;
      } catch (_) {
        if (this.request !== request || !this.isConnected) return;
        this.querySelector('[data-resource-reload]').href = reloadUrl;
        this.querySelector('[data-resource-error]').hidden = false;
        this.hidden = false;
      } finally {
        if (this.request === request) clearTimeout(this.timeout);
        if (this.request === request && this.isConnected) this.syncLayout();
      }
    }
  }
  customElements.define('hh-product-resources', ProductResources);
})();
